import { io } from "socket.io-client";
import { MODE } from "../utility/constants";

export const URL =
  MODE == "DEV" ? "http://localhost:3030" : "https://admin.alhamroorhazard.com";

export const socket = io(URL).connect();

socket.on("connect_error", (err) => console.log(`connect_error due to ${err}`));

socket.on("connect", () => console.log("socket connected"));

socket.on("disconnect", () => console.log("socket disconnected"));

export default {
  install(app) {
    app.provide("socket", socket);
  },
};
